<template>
  <div class="container-fluid">
    <div class="row mr-4">
      <a v-if="AddEditMode != 0">
        <h4 @click="AddEditMode = 0" class="fas fa-times text-danger"></h4>
      </a>
      <a v-else data-title="افزودن جدید">
        <h4
          @click="
            AddEditMode = 1
            DataAxios = JSON.parse(JSON.stringify(EmptyAxios))
          "
          class="fas fa-plus text-logo"
        ></h4>
      </a>
    </div>
    <user-info-header></user-info-header>

    <div v-if="AddEditMode != 0" :id="$route.name">
      <div class="row">
        <div class="col-md-3 col-12">
          <small id="LbltblComboGrp102RoozaneSaati">نوع درخواست :</small>
          <SearchableCombo :defaultvalue="DataAxios.tblComboGrp102RoozaneSaati" :edit="false" :grp="102" :code="null" @ResultCombo="GetCombogrp102" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Natije'" :keyItem="'Natije'" :disabled="false"> </SearchableCombo>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 col-12 mt-2">
          <small id="Lbldate">تاریخ :</small>
          <date-picker color="dimgray" v-model="DataAxios.date" auto-submit input-class="required form-control" id="DateStart" clearable :editable="true" placeholder=" تاریخ " ></date-picker>
        </div>
        <div class="col-md-2 col-12 mt-2" v-if="DataAxios.tblComboGrp102RoozaneSaati == 1085235">
          <!-- <small>تاریخ پایان:</small>
            <date-picker color="dimgray" auto-submit input-class="required form-control" id="DateEnd" clearable :editable="true" placeholder=" تاریخ "></date-picker> -->
          <small id="LbldayCount">به مدت</small>
          <input v-model="DataAxios.dayCount" :disabled="DataAxios.tblComboGrp102RoozaneSaati == 1085236" type="number" @keypress="$ValidNumber($event, 1, true)" placeholder="روز" class="form-control" />
        </div>
        <!-- <div class="col-md-2 col-12 mt-2"></div> -->
        <div class="col-md-2 col-12 mt-2" v-if="DataAxios.tblComboGrp102RoozaneSaati != 1085235">
          <small id="LblstartTime">زمان شروع:</small>
          <date-picker :disabled="DataAxios.tblComboGrp102RoozaneSaati != 1085236" color="dimgray" type="time" v-model="DataAxios.startTime" auto-submit input-class="required form-control" id="DateStart" clearable :editable="true" placeholder=" ساعت "></date-picker>
        </div>
        <div class="col-md-2 col-12 mt-2" v-if="DataAxios.tblComboGrp102RoozaneSaati != 1085235">
          <small id="LblendTime">زمان پایان:</small>
          <date-picker :disabled="DataAxios.tblComboGrp102RoozaneSaati != 1085236" color="dimgray" type="time" v-model="DataAxios.endTime" auto-submit input-class="required form-control" id="DateStart" clearable :editable="true" placeholder=" ساعت "></date-picker>
        </div>
        <div class="col-md-2 col-12 mt-5" v-if="DataAxios.tblComboGrp102RoozaneSaati != 1085235">
          <small id="LblSubtractTime">به مدت: </small>&nbsp;
          <span class="h6">{{ DataAxios.startTime!='' && DataAxios.endTime!='' ? $SubtractTime(DataAxios.startTime, DataAxios.endTime) + '  ساعت' : '--' }}</span>
        </div>
        <div class="col-12">
          <hr class="mt-2" />
        </div>
        <div class="col-lg-8 mt-3">
          <small id="Lbldes">شرح انجام کار</small>
          <textarea v-model="DataAxios.des" class="form-control" id="" cols="30" rows="5"></textarea>
        </div>
        <div class="col-lg-4 mt-3 col-12">
          <small id="LblFilePath">بارگذاری مدارک</small>
          <uploader @upload="GetFile"></uploader>
        </div>
        <div class="col-md-8 col-12"></div>
        <div class="col-md-2 col-12"></div>
        <div class="col-md-2 col-12">
          <div class="row mt-4 px-3">
            <button v-if="AddEditMode == 1" @click="CheckError" class="btn w-100 btn-success">ثبت درخواست</button>
            <button v-if="AddEditMode == 2" @click="CheckError" class="btn w-100 btn-warning">ویرایش درخواست</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="AddEditMode == 0" class="row mt-2">
      <div class="col-md-4 col-12">
        <div class="mt-2">
          <small id="LblName"> نوع درخواست : </small>
          <select class="form-control" v-model="Filter.tblCombogrp102NoeDarkhast">
            <option v-for="(item, key) in ListGrp102NoeDarkhast" :key="key" :value="item.id">{{ item.name }}</option>
            <option :value="null">همـــه</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-12 mt-2">
        <small>از تاریخ </small>
        <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixAz" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
      </div>
      <div class="col-md-3 col-12 mt-2">
        <small>تا تاریخ </small>
        <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixTa" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
      </div>
      <div class="col-md-2 col-12 mt-4">
        <button type="button" class="btn btn-success w-100 mt-1" @click="GetListOverTime"><i class="fad fa-search mt-1 ml-2"></i> اعمال فیلتر</button>
      </div>
    </div>
    <div v-if="AddEditMode == 0" class="row">
      <div class="col-12">
        <bnp-grid :key="tableKey" :hasRowNum="true" :propsColumn="Column" :propsRows="rows" :Selectable="false" :action="true" :ShowDetail="true">
          <template slot="filePath" slot-scope="props">
            <div v-if="props.props.filePath==null || props.props.filePath==='null'">
              <span class="text-danger">ندارد</span>
            </div>
            <div class="" v-else>
              <a target="_blank" :download="props.props.date" v-if="props.props.filePath != null" :href="$cookies.get('URL') + props.props.filePath"> <i class="fad fa-download"></i></a>
            </div>
          </template>
          <template slot="startTime" slot-scope="props">
            {{ props.props.startTime == 'null ' ? '-' : props.props.startTime }}
          </template>
          <template slot="endTime" slot-scope="props">
            {{ props.props.endTime == 'null ' ? '-' : props.props.endTime }}
          </template>

          <template slot="dayCount" slot-scope="props">
            {{ props.props.tblComboGrp102RoozaneSaati != 1085235 ? $SubtractTime(props.props.startTime, props.props.endTime) + ' ساعت ' : props.props.dayCount + ' روز ' }}
          </template>
          <template slot="action-slot" slot-scope="props">
            <request-info :RequestRow="props.props" :ApiAction="$route.name" @DataEdit="EditData" @Success="GetDate" :IsSarparast="false" :IsDelete="true" :IsEdit="true" :FormAutomation="ControlName"></request-info>
          </template>
          <template slot="Detail">
            <!-- <div class="Detail mt-3 p-2">
              <span>میزان مرخصی دریافتی شما بر اساس فیلتر جستجو </span>
              <span class="text-danger"> {{ GetCountLeveReq() }} </span>
              <span> می باشد </span>
            </div> -->
             <div class="Detail mt-3 p-2">
              <span>میزان {{ FormId==2?'اضافه کاری':'ماموریت' }} دریافتی شما بر اساس فیلتر جستجو </span>
              <span class="text-danger"> {{ GetFullTimeRequest(rows) }} </span>
              <span> می باشد </span>
            </div>
          </template>
        </bnp-grid>
      </div>
    </div>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import UserInfoHeader from '@/components/AutomAtion/UserInfoHeader.vue'
import datePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import RequestInfo from './RequestInfo.vue'
import moment from 'moment-jalaali'

export default {
  components: { BnpGrid, datePicker, UserInfoHeader, SearchableCombo, Uploader, RequestInfo },
  props: ['Column', 'FormId', 'rowForEdit'],
  data() {
    return {
      Flag:false,
      rowForEditLocal:{},
      ControllerAddress: '',
      AddEditMode: 0,
      tableKey: 0,
      rows: [],
      DataAxios: {
        id: 22,
        tblUserId: this.$session.get('UserInfo').tblUserId,
        dateTimeInsert: '',
        dateLastEdit: ' ',
        tblUserGrpIdInsert: 0,
        tblUserGrpIdLastEdit: null,
        date: this.$GetJalaliDate(),
        dayCount: null,
        tblComboGrp102RoozaneSaati: null,
        endTime: '',
        startTime: this.$GetJalaliDateTime().substr(11),
        des: '',
        filepath: null,
      },

      EmptyAxios: {
        id: 22,
        tblUserId: this.$session.get('UserInfo').tblUserId,
        dateTimeInsert: '',
        dateLastEdit: null,
        tblUserGrpIdInsert: 0,
        tblUserGrpIdLastEdit: null,
        date: this.$GetJalaliDate(),
        dayCount: null,
        tblComboGrp102RoozaneSaati: null,
        endTime: '',
        startTime: this.$GetJalaliDateTime().substr(11),
        des: null,
        filepath: null,
      },
      Arryfildvalue: this.DataAxios,
      File: null,
      Filter: { tblUserId: this.$session.get('UserInfo').tblUserId, tblCombogrp102NoeDarkhast: null, tarixTa: '', tarixAz: '' },
      ListGrp102NoeDarkhast: [],
      ControlName:""
    }
  },
  created() {
    this.GetFormAutomationId();
    if (this.rowForEdit) {
      this.AddEditMode = this.rowForEdit ? 2 : 0
      this.DataAxios = this.rowForEdit
    } else {
      this.GetCombo(102)
      this.Filter.tarixAz = this.$GetFirstAndLastDayOfMonth().SDate
      this.Filter.tarixTa = this.$GetFirstAndLastDayOfMonth().EDate
    }
    this.ControllerAddress = this.$route.name
    this.GetListOverTime()
  },
  mounted() {},
  methods: {
    GetCombogrp102(data) {
      if (data.id != null) {
        if (this.rowForEdit ) {
          console.log("😎 ~ GetResulGrp102 ~ this.rowForEdit:", JSON.parse(this.rowForEdit))
          console.log("😎 ~ GetResulGrp102 ~ this.rowForEdit:", this.Flag)
        } 
        if (this.Flag==true) {
          this.Flag=false
        }
        else {
          if (data.id == 1085235) {
            this.EmptyAxios.startTime=""
          } else {
            this.EmptyAxios.startTime=this.$GetJalaliDateTime().substr(11)
          }
          this.DataAxios = JSON.parse(JSON.stringify(this.EmptyAxios))
        }
        this.DataAxios.tblComboGrp102RoozaneSaati = data.id
      }
    },
    CheckError() {
      if (this.DataAxios.tblComboGrp102RoozaneSaati == null) {
        this.$mySweetDefaultTost('هشدار', 'لطفا نوع درخواست  (روزانه/ساعتی) را مشخص کنید', 'warning', 2000)
      } else {
        //شرط های ساعتی
        if (this.DataAxios.tblComboGrp102RoozaneSaati == 1085236) {
          if (this.DataAxios.startTime=='') {
            this.$mySweetDefaultTost('هشدار', 'ساعت شروع درخواست را مشخص کنید!', 'warning', 2000)
          } else if (this.DataAxios.endTime.length != 5) {
            this.$mySweetDefaultTost('هشدار', 'ساعت پایان درخواست را مشخص کنید!', 'warning', 2000)
          } else {
            if (this.AddEditMode == 1) {
              this.AddRequest()
            } else if (this.AddEditMode == 2) {
              this.EditRequest()
            }
          }
        }
        //شرط های روزانه
        else {
          if (this.DataAxios.date.trim().length != 10) {
            this.$mySweetDefaultTost('هشدار', 'تاریخ را مشخص نکرده اید', 'warning', 2000)
          } else if (this.DataAxios.dayCount == 0 || this.DataAxios.dayCount == null) {
            this.$mySweetDefaultTost('هشدار', 'تعداد روز درخواست را مشخص کنید!', 'warning', 2000)
          } else {
            if (this.AddEditMode == 1) {
              this.AddRequest()
            } else if (this.AddEditMode == 2) {
              this.EditRequest()
            }
          }
        }
      }
    },
    EditRequest() {
      var SendData = { Action: this.$route.name + '/Edit', Method: 'POST', ArryfildValue: null }
      var formData = new FormData()
      for (var key in this.DataAxios) {
        if (this.DataAxios[key] == null || this.DataAxios[key] == '') {
          formData.append(key, null)
        } else {
          formData.append(key, this.DataAxios[key])
        }
      }
      console.log(formData)
      formData.append('file', this.File)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        console.log("😎 ~ this.$PostFormData ~ result:", result)
        if (result.status == 'success') {
          this.$SetLog(this.DataAxios, 0, 0)
          this.$toasted.success('درخواست شما با موفقیت ثبت شد', { duration: 3500 })
          this.AddEditMode = 0
          this.DataAxios = JSON.parse(JSON.stringify(this.EmptyAxios))
          this.GetListOverTime()
        } else {
          this.$toasted.error(result.msg, { duration: 3000 })
        }
      })
    },
    AddRequest() {
      var SendData = { Action: this.$route.name + '/Add', Method: 'POST', ArryfildValue: null }
      var formData = new FormData()
      for (var key in this.DataAxios) {
        if (this.DataAxios[key] == null || this.DataAxios[key] == '') {
          formData.append(key, null)
        } else {
          formData.append(key, this.DataAxios[key])
        }
      }
      formData.append('file', this.File)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.status == 'success') {
          this.$toasted.success('درخواست شما با موفقیت ثبت شد', { duration: 3500 })
          this.tableKey++
          this.AddEditMode = 0
          this.DataAxios = JSON.parse(JSON.stringify(this.EmptyAxios))
          this.GetListOverTime()
        }
      })
    },
    GetFile(data) {
      this.File = data
    },
    GetDate(val) {
      // this.$PostData({ ArryfildValue: null, Method: 'GET', Action: this.$route.name + '/?Id=' + this.$session.get('UserInfo').tblUserId }).then((result) => {
      //   this.rows = result
      //   this.tableKey++
      // })
      if (val == true) {
        this.GetListOverTime()
        this.tableKey++
      }
    },
    EditData(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      this.AddEditMode = 2
      this.Flag=true
      if (this.FormId == 3) {
        //ماموریت
        this.DataAxios = row
      } else {
        //اضافه کاری
        this.DataAxios = {
          id: row.id,
          tblUserId: this.$session.get('UserInfo').tblUserId,
          dateTimeInsert: row.dateTimeInsert,
          dateLastEdit: '',
          tblUserGrpIdInsert: row.tblUserGrpIdInsert,
          tblUserGrpIdLastEdit: null,
          date: row.date.trim(),
          dayCount: row.dayCount,
          tblComboGrp102RoozaneSaati: row.tblComboGrp102RoozaneSaati,
          endTime: row.endTime,
          startTime: row.startTime,
          des: row.des,
          filepath: null,
        }
      }
    },
    GetCombo(GRP) {
      let DataAxios_SetData = {
        ArryfildValue: { Id: GRP, Usergrp: null },
        Method: 'post',
        Action: 'TblCrmCombo/GetComboById',
      }
      this.$PostData(DataAxios_SetData).then((data) => {
        if (GRP == 102) {
          this.ListGrp102NoeDarkhast = data
        }
        if (GRP == 103) {
          this.ListGrp103NoeMorakhasi = data
        }
        return data
      })
    },
    GetListOverTime() {
      let DataAxios_SetData = {
        ArryfildValue: this.Filter,
        Method: 'POST',
        Action: this.$route.name + '/GetData',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          this.rows = data
          this.tableKey++
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetCountLeveReq() {
      var Day = 0
      var Time = '00:00'
      this.rows.forEach((e) => {
        if (e.dayCount != null) {
          Day += e.dayCount
        }
        if (e.dayCount == null) {
          let T = this.$SubtractTime(e.startTime, e.endTime)
          Time = this.$SumTime(Time, T)
          let compare = this.$CompareTime('24:00', Time)
          if (compare != 0) {
            Time = compare
            Day++
          }
        }
      })
      return Day + ' روز ' + Time + ' ساعت | دقیقه '
    },
    GetFullTimeRequest(lsitReq){
      let Day=0;
      let Minutes="00:00";
     
       if (this.FormId==2){
        Day=0;
        Minutes="00:00"
        lsitReq.map((el)=>{
          if (el.dayCount!=null) {
            Day+=el.dayCount
          }
          else{
           let formattedTime= this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes=this.$addTimes(Minutes, formattedTime.substring(0,5))
          }
        })
        return (Day + ' روز و ' + Minutes + ' ساعت ')
      }
      else if (this.FormId==3){
        Day=0;
        Minutes="00:00"
        lsitReq.map((el)=>{
          if (el.dayCount!=null) {
            Day+=el.dayCount
          }
          else{
           let formattedTime= this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes=this.$addTimes(Minutes, formattedTime.substring(0,5))
          }
        })
        return (Day + ' روز و ' + Minutes + ' ساعت ')
      }
      
      console.log("😎 ~ GetFullTimeLeaveReq ~ lsitReq:", lsitReq)
      
    },
    GetFormAutomationId(){
      this.$FindTableNameOnAutomationCartabl(this.FormId).then((res) => {
             this.ControlName= res
            })
    }
  },
}
</script>
<style>
.Detail {
  color: var(--sidebar-color-item) !important;
  background-color: var(--table-background) !important;
  border-radius: 5px;
}
</style>
